import React from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import {
	Modal,
	ModalContent,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Button,
	Textarea,
} from "@heroui/react";
import { TRequest } from "@shared/entities";

const AdminRejectRequestSchema = z.object({
	adminMessageForClient: z.string().optional(),
});

type TAdminRejectRequestForm = z.infer<typeof AdminRejectRequestSchema>;

interface AdminRejectRequestModalProps {
	request: TRequest;
	onSubmit: (data: TAdminRejectRequestForm) => void;
	onClose: () => void;
}

export const AdminRejectRequestModal: React.FC<AdminRejectRequestModalProps> = ({
	request,
	onSubmit,
	onClose,
}) => {
	const form = useForm<TAdminRejectRequestForm>({
		resolver: zodResolver(AdminRejectRequestSchema),
		defaultValues: {
			adminMessageForClient: "",
		},
	});

	const handleSubmit = (data: TAdminRejectRequestForm) => {
		onSubmit(data);
	};

	return (
		<Modal isOpen={true} onClose={onClose} size="2xl">
			<ModalContent>
				<ModalHeader className="flex flex-col gap-1">דחיית בקשה</ModalHeader>
				<ModalBody>
					<div className="space-y-6">
						<div className="text-sm text-default-600">
							אתה עומד לדחות את הבקשה של {request.clientDetails?.firstName}{" "}
							{request.clientDetails?.lastName}. אם תרצה, תוכל להוסיף הודעות לרופא ו/או
							ללקוח.
						</div>

						<div className="space-y-4">
							<Textarea
								label="הודעה ללקוח (אופציונלי)"
								placeholder="הודעה שתישלח ללקוח..."
								{...form.register("adminMessageForClient")}
								className="w-full"
								minRows={3}
							/>
						</div>
					</div>
				</ModalBody>
				<ModalFooter>
					<Button color="default" variant="light" onPress={onClose}>
						ביטול
					</Button>
					<Button
						color="danger"
						onPress={() => form.handleSubmit(handleSubmit)()}
						isLoading={form.formState.isSubmitting}
					>
						דחה בקשה
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};
